export default "__VITE_ASSET__CPZC5$lO__"